module.exports = __webpack_public_path__ + "static/media/1POLICY43.58de8801.jpg";